export const bannerSlides = [
  {
    id: 1,
    title: '庆余年 第二季',
    subtitle: '张若昀 李沁 领衔主演 · 古装权谋巅峰之作',
    description: '范闲归来，京都风云再起！2024年最受期待古装大剧，全网播放量突破百亿',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20historical%20drama%20scene%20with%20ancient%20palace%20architecture%20in%20warm%20golden%20and%20amber%20lighting%2C%20dramatic%20cinematic%20composition%2C%20misty%20atmosphere%2C%20artistic%20illustration%20style%2C%20rich%20warm%20color%20palette%20with%20deep%20oranges%20and%20golden%20hues&width=1920&height=800&seq=banner-slide-01&orientation=landscape',
    category: '电视剧',
    rating: 9.5,
    link: '/article/qingyunian-2',
    badge: '热播中',
    badgeBg: 'bg-accent-500',
  },
  {
    id: 2,
    title: '流浪地球3',
    subtitle: '吴京 刘德华 主演 · 中国科幻史诗巨制',
    description: '太阳危机升级，人类命运何去何从？国产科幻巅峰之作，视觉特效全面突破',
    image: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20cinematic%20scene%20with%20massive%20spaceship%20and%20distant%20planets%2C%20dramatic%20warm%20orange%20and%20golden%20nebula%20lighting%2C%20artistic%20illustration%20style%2C%20grand%20scale%20composition%2C%20deep%20space%20atmosphere&width=1920&height=800&seq=banner-slide-02&orientation=landscape',
    category: '电影',
    rating: 9.3,
    link: '/article/liulangdiqiu-3',
    badge: '热映中',
    badgeBg: 'bg-primary-500',
  },
  {
    id: 3,
    title: '乘风破浪的姐姐 第五季',
    subtitle: '全明星阵容 · 年度最热综艺回归',
    description: '30位姐姐集结，再掀舞台风暴！音乐、舞蹈、戏剧，全方位展现女性力量',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20stage%20performance%20scene%20with%20dramatic%20spotlight%20and%20flowing%20fabric%2C%20warm%20golden%20and%20rose%20lighting%2C%20artistic%20illustration%20style%2C%20theatrical%20composition%2C%20vibrant%20yet%20sophisticated%20color%20palette&width=1920&height=800&seq=banner-slide-03&orientation=landscape',
    category: '综艺',
    rating: 9.1,
    link: '/article/chenglang-5',
    badge: '热播中',
    badgeBg: 'bg-accent-500',
  },
];

export const categories = [
  { id: 'all', name: '全部', icon: 'ri-apps-line' },
  { id: 'movie', name: '电影', icon: 'ri-film-line' },
  { id: 'tv', name: '电视剧', icon: 'ri-tv-line' },
  { id: 'variety', name: '综艺', icon: 'ri-music-line' },
  { id: 'anime', name: '动漫', icon: 'ri-emotion-line' },
  { id: 'documentary', name: '纪录片', icon: 'ri-slideshow-line' },
  { id: 'kids', name: '少儿', icon: 'ri-parent-line' },
];

export const hotVideos = [
  {
    id: 1,
    title: '庆余年 第二季',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20with%20ancient%20warrior%20in%20flowing%20robe%2C%20artistic%20illustration%20style%2C%20warm%20golden%20and%20amber%20tones%2C%20dramatic%20lighting%2C%20clean%20simple%20background&width=400&height=560&seq=hot-video-01&orientation=portrait',
    category: '电视剧',
    rating: 9.5,
    updateTo: '更新至36集',
    link: '/article/qingyunian-2',
    badge: 'VIP',
  },
  {
    id: 2,
    title: '流浪地球3',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20with%20astronaut%20and%20giant%20planet%2C%20artistic%20illustration%20style%2C%20deep%20orange%20and%20golden%20tones%2C%20dramatic%20composition%2C%20simple%20clean%20background&width=400&height=560&seq=hot-video-02&orientation=portrait',
    category: '电影',
    rating: 9.3,
    updateTo: 'HD高清',
    link: '/article/liulangdiqiu-3',
    badge: '热播',
  },
  {
    id: 3,
    title: '乘风破浪的姐姐5',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20elegant%20female%20performers%20on%20stage%2C%20artistic%20illustration%20style%2C%20warm%20rose%20and%20golden%20lighting%2C%20glamorous%20atmosphere%2C%20simple%20clean%20background&width=400&height=560&seq=hot-video-03&orientation=portrait',
    category: '综艺',
    rating: 9.1,
    updateTo: '更新至第8期',
    link: '/article/chenglang-5',
    badge: '热播',
  },
  {
    id: 4,
    title: '斗罗大陆2：绝世唐门',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20poster%20with%20fantasy%20warrior%20character%20holding%20glowing%20weapon%2C%20artistic%20illustration%20style%2C%20warm%20amber%20and%20golden%20tones%2C%20epic%20fantasy%20atmosphere%2C%20simple%20clean%20background&width=400&height=560&seq=hot-video-04&orientation=portrait',
    category: '动漫',
    rating: 9.4,
    updateTo: '更新至52集',
    link: '/article/douluo-2',
    badge: 'VIP',
  },
  {
    id: 5,
    title: '繁花',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%20with%20elegant%20couple%20in%20vintage%20Shanghai%20style%20clothing%2C%20artistic%20illustration%2C%20warm%20golden%20and%20nostalgic%20tones%2C%20sophisticated%20atmosphere%2C%20simple%20background&width=400&height=560&seq=hot-video-05&orientation=portrait',
    category: '电视剧',
    rating: 9.6,
    updateTo: '全30集',
    link: '/article/fanhua',
    badge: '完结',
  },
  {
    id: 6,
    title: '飞驰人生2',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20racing%20comedy%20movie%20poster%20with%20race%20car%20and%20dynamic%20motion%2C%20artistic%20illustration%20style%2C%20warm%20orange%20and%20golden%20tones%2C%20energetic%20atmosphere%2C%20simple%20clean%20background&width=400&height=560&seq=hot-video-06&orientation=portrait',
    category: '电影',
    rating: 8.9,
    updateTo: 'HD高清',
    link: '/article/feichi-2',
    badge: '热播',
  },
  {
    id: 7,
    title: '长相思',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20drama%20poster%20with%20beautiful%20couple%20in%20flowing%20ancient%20costumes%2C%20artistic%20illustration%20style%2C%20warm%20peach%20and%20golden%20tones%2C%20romantic%20ethereal%20atmosphere%2C%20simple%20background&width=400&height=560&seq=hot-video-07&orientation=portrait',
    category: '电视剧',
    rating: 9.2,
    updateTo: '全39集',
    link: '/article/changxiangsi',
    badge: '完结',
  },
  {
    id: 8,
    title: '王牌对王牌 第八季',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20game%20show%20poster%20with%20cheerful%20celebrities%20playing%20games%2C%20artistic%20illustration%20style%2C%20warm%20golden%20and%20vibrant%20tones%2C%20fun%20energetic%20atmosphere%2C%20simple%20background&width=400&height=560&seq=hot-video-08&orientation=portrait',
    category: '综艺',
    rating: 8.8,
    updateTo: '更新至第12期',
    link: '/article/wangpai-8',
    badge: '热播',
  },
];

export const latestUpdates = [
  {
    id: 1,
    title: '南来北往',
    episode: '第38集',
    category: '电视剧',
    time: '2小时前',
    link: '/article/nanlainbeiwang',
  },
  {
    id: 2,
    title: '大江大河3',
    episode: '第32集',
    category: '电视剧',
    time: '3小时前',
    link: '/article/dajiangdahe-3',
  },
  {
    id: 3,
    title: '年会不能停！',
    episode: 'HD高清',
    category: '电影',
    time: '5小时前',
    link: '/article/nianhui',
  },
  {
    id: 4,
    title: '奔跑吧 生态篇',
    episode: '第10期',
    category: '综艺',
    time: '6小时前',
    link: '/article/benpao-eco',
  },
  {
    id: 5,
    title: '斗破苍穹 年番',
    episode: '第98集',
    category: '动漫',
    time: '8小时前',
    link: '/article/doupo-nianfan',
  },
  {
    id: 6,
    title: '三大队',
    episode: 'HD高清',
    category: '电影',
    time: '10小时前',
    link: '/article/sandadui',
  },
  {
    id: 7,
    title: '神隐',
    episode: '第40集',
    category: '电视剧',
    time: '12小时前',
    link: '/article/shenyin',
  },
  {
    id: 8,
    title: '这就是街舞 第六季',
    episode: '第12期',
    category: '综艺',
    time: '14小时前',
    link: '/article/jiewu-6',
  },
  {
    id: 9,
    title: '完美世界',
    episode: '第165集',
    category: '动漫',
    time: '16小时前',
    link: '/article/wanmei',
  },
  {
    id: 10,
    title: '我本是高山',
    episode: 'HD高清',
    category: '电影',
    time: '18小时前',
    link: '/article/gaoshan',
  },
];

export const faqList = [
  {
    id: 1,
    question: '芒果视频真的完全免费吗？',
    answer: '是的！芒果视频承诺对所有用户提供完全免费的影视观看服务。我们通过广告合作维持运营，用户无需支付任何费用即可观看海量电影、电视剧、综艺、动漫等内容。无论是热门大片还是经典老剧，全部免费播放，无任何隐藏收费。',
  },
  {
    id: 2,
    question: '芒果视频的画质怎么样？支持哪些清晰度？',
    answer: '芒果视频提供360P至1080P多种清晰度选择，部分热门内容支持4K超清画质。我们采用先进的视频编码技术和CDN加速，确保播放流畅不缓冲。您可以根据网络状况自由切换清晰度，获得最佳观看体验。',
  },
  {
    id: 3,
    question: '芒果视频和西瓜视频免费、91视频有什么区别？',
    answer: '芒果视频作为西瓜视频免费和91视频的优质替代平台，具有以下优势：1）资源更全面，涵盖电影、电视剧、综艺、动漫、纪录片全品类；2）更新更及时，同步各大平台最新内容；3）播放更流畅，采用最新P2P加速技术；4）界面更清爽，无弹窗广告干扰；5）完全免费，无需注册也可观看。',
  },
  {
    id: 4,
    question: '芒果视频支持哪些设备观看？',
    answer: '芒果视频支持全平台观看，包括电脑网页版、手机网页版、平板等所有设备。无论您使用Windows、Mac、iOS还是Android系统，都可以通过浏览器直接访问芒果视频，无需下载任何APP即可享受流畅的观影体验。',
  },
  {
    id: 5,
    question: '芒果视频的内容更新频率如何？',
    answer: '芒果视频每天24小时不间断更新。热门电视剧和综艺节目通常在播出后2-4小时内上线，电影资源在院线下线后第一时间更新。我们拥有专业的资源团队，确保您能在芒果视频第一时间看到最新、最热的影视内容。',
  },
  {
    id: 6,
    question: '观看芒果视频需要注册账号吗？',
    answer: '不需要！芒果视频支持免注册直接观看。您可以直接打开网站，选择喜欢的影片即可开始播放。当然，注册账号后可以享受收藏、历史记录、观影进度同步等更多便捷功能，完全由您自由选择。',
  },
];

export const aboutInfo = {
  brand: {
    title: '关于芒果视频',
    description: '芒果视频成立于2023年，是国内领先的免费在线视频平台。我们致力于为用户提供海量优质的影视内容，涵盖电影、电视剧、综艺、动漫、纪录片等多个品类。作为一个完全免费的在线视频观看平台，芒果视频已成为西瓜视频免费和91视频的最佳替代选择，每天为数百万用户提供高清流畅的观影体验。',
    mission: '让每个人都能免费享受优质的影视内容',
    vision: '成为全球最大的华语免费视频平台',
    values: ['用户至上', '内容为王', '技术驱动', '免费普惠'],
  },
  stats: [
    { label: '视频总量', value: '100,000+', icon: 'ri-film-line' },
    { label: '日活用户', value: '500万+', icon: 'ri-user-line' },
    { label: '月更新量', value: '3,000+', icon: 'ri-upload-line' },
    { label: '好评率', value: '98.5%', icon: 'ri-heart-line' },
  ],
  contact: {
    email: 'contact@mangovideo.com',
    wechat: 'mangovideo_official',
    qq: '800123456',
    phone: '400-888-6666',
    address: '北京市朝阳区望京科技园A座18层',
  },
  testimonials: [
    {
      id: 1,
      name: '王先生',
      content: '用了芒果视频快一年了，资源真的超级全！以前在西瓜视频免费上找不到的资源这里都有，而且完全免费，画质还特别好，强烈推荐！',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20photo%2C%20warm%20lighting%2C%20simple%20clean%20background%2C%20friendly%20expression&width=100&height=100&seq=avatar-testimonial-01&orientation=squarish',
    },
    {
      id: 2,
      name: '李女士',
      content: '比91视频好用太多了！界面清爽没有乱七八糟的广告，追剧特别方便。更新也很快，热门剧基本同步更新，免费的能做成这样真的很良心。',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20photo%2C%20warm%20lighting%2C%20simple%20clean%20background%2C%20gentle%20smile&width=100&height=100&seq=avatar-testimonial-02&orientation=squarish',
    },
    {
      id: 3,
      name: '张同学',
      content: '学生党福音！作为一个在校大学生，芒果视频完全免费真的太香了。动漫资源特别全，斗罗大陆、完美世界这些都有，而且更新速度超级快。',
      avatar: 'https://readdy.ai/api/search-image?query=Casual%20young%20Chinese%20student%20portrait%20photo%2C%20warm%20lighting%2C%20simple%20clean%20background%2C%20bright%20smile&width=100&height=100&seq=avatar-testimonial-03&orientation=squarish',
    },
  ],
};

export const articleData = {
  'qingyunian-2': {
    title: '庆余年 第二季',
    category: '电视剧',
    rating: 9.5,
    updateTo: '更新至36集',
    year: 2024,
    region: '中国大陆',
    director: '孙皓',
    cast: '张若昀、李沁、陈道明、吴刚、郭麒麟',
    description: '《庆余年》第二季延续第一季的故事线，范闲在经历了第一季的种种历险后，逐渐揭开了自己身世之谜。他不再是那个懵懂的穿越者，而是开始主动参与到庆国权力斗争的漩涡之中。第二季将围绕范闲与庆帝之间的博弈展开，同时范闲与林婉儿的感情线也将有重大发展。更大的阴谋、更深的权谋、更震撼的真相，一切尽在《庆余年》第二季。',
    content: `<p>《庆余年》第二季终于回归！作为近年来最受关注的古装IP剧集，第二季延续了第一季的高品质制作水准，同时在剧情深度和角色塑造上有了更大的突破。</p>

<h3>剧情概述</h3>
<p>第二季的故事承接第一季结尾，范闲在经历了诸多磨难后，逐渐在庆国朝堂上站稳了脚跟。然而，随着他对母亲叶轻眉之死的深入调查，一个更加庞大的阴谋逐渐浮出水面。范闲不得不在亲情、爱情和家国大义之间做出艰难抉择。</p>

<h3>角色亮点</h3>
<p>张若昀饰演的范闲在第二季中展现出更加成熟的一面，从第一季的"被迫成长"到如今的"主动出击"，角色弧光十分完整。李沁饰演的林婉儿也在第二季中有更加丰富的戏份，不再是单纯的"花瓶"角色。特别值得一提的是陈道明饰演的庆帝，其深沉老练的帝王心术令人拍案叫绝。</p>

<h3>制作水准</h3>
<p>第二季的制作预算相比第一季大幅增加，服化道、场景布置、特效制作均有显著提升。特别是大型战争场面和宫廷礼仪场景，视觉效果堪称国产剧标杆。配乐方面由知名作曲家操刀，主题曲更是请到了华语乐坛顶级歌手演唱。</p>

<h3>观众评价</h3>
<p>截至目前，《庆余年》第二季在各大平台的评分均保持在9分以上，被网友誉为"2024年最强国产剧"。观众普遍认为，第二季在保持第一季轻松幽默基调的同时，增加了更多悬疑和权谋元素，可看性更强。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20cinematic%20scene%20with%20ancient%20palace%20and%20warriors%2C%20warm%20golden%20lighting%2C%20epic%20atmosphere%2C%20artistic%20style%2C%20rich%20amber%20tones&width=800&height=450&seq=article-qyn-01&orientation=landscape',
  },
  'liulangdiqiu-3': {
    title: '流浪地球3',
    category: '电影',
    rating: 9.3,
    updateTo: 'HD高清',
    year: 2024,
    region: '中国大陆',
    director: '郭帆',
    cast: '吴京、刘德华、李雪健、沙溢、宁理',
    description: '《流浪地球3》作为中国科幻电影的里程碑之作，将故事推向更加宏大的宇宙舞台。在地球成功脱离木星引力后，人类面临着新的挑战——太阳氦闪危机提前到来。人类必须做出选择：是继续带着地球流浪，还是启动"火种计划"？',
    content: `<p>《流浪地球3》——中国科幻的新高度！郭帆导演再次用震撼的视觉奇观和深刻的人文思考，将中国科幻电影推向了前所未有的高度。</p>

<h3>故事背景</h3>
<p>在成功脱离木星引力后，地球继续在宇宙中流浪。然而，太阳的演化速度超出了科学家的预期，氦闪危机提前到来。人类联合政府面临着前所未有的抉择：继续"流浪地球"计划，还是启动备用的"火种计划"——由领航员空间站携带人类文明的火种独自远航。</p>

<h3>视觉突破</h3>
<p>《流浪地球3》在视觉效果上实现了全面突破，全片特效镜头超过3000个，由中科院科学家担任科学顾问，确保每一个宇宙场景都有科学依据。从太阳氦闪的壮观景象到行星发动机的全功率启动，每一个画面都令人叹为观止。</p>

<h3>演员表现</h3>
<p>吴京继续饰演刘培强，这次他的角色面临更加艰难的道德困境。刘德华饰演的图恒宇在第三部中有着更加关键的戏份，其角色的深度和复杂度都达到了新的高度。李雪健、沙溢等实力派演员的加盟，为影片增添了更多看点。</p>

<h3>主题升华</h3>
<p>如果说前两部探讨的是"人类如何活下去"，那么第三部则进一步追问"人类为什么值得活下去"。影片在保持宏大叙事的同时，更加关注个体在危机中的选择和牺牲，具有深刻的哲学思考。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20cinematic%20scene%20with%20giant%20planet%20and%20spaceships%20in%20deep%20space%2C%20warm%20orange%20and%20golden%20nebula%20lighting%2C%20grand%20scale%2C%20artistic%20style&width=800&height=450&seq=article-ldq-01&orientation=landscape',
  },
  'chenglang-5': {
    title: '乘风破浪的姐姐 第五季',
    category: '综艺',
    rating: 9.1,
    updateTo: '更新至第8期',
    year: 2024,
    region: '中国大陆',
    director: '芒果TV制作团队',
    cast: '30位实力女艺人',
    description: '《乘风破浪的姐姐》第五季强势回归！30位来自不同领域的实力女艺人齐聚一堂，通过音乐、舞蹈、戏剧等多轮竞演，展现女性在不同年龄阶段的光芒与魅力。',
    content: `<p>《乘风破浪的姐姐》第五季——30+女性的闪耀舞台！本季节目在赛制和内容上进行了全面升级，更加注重展现姐姐们的个人成长和团队协作。</p>

<h3>节目亮点</h3>
<p>第五季最大的看点是参赛阵容的空前强大，不仅有实力唱将、知名演员，还有跨界而来的运动员和企业家。每一位姐姐都带着自己的故事和梦想来到舞台，用实力打破年龄的刻板印象。</p>

<h3>赛制创新</h3>
<p>本季新增了"踢馆赛"和"复活赛"机制，增加了节目的不确定性和看点。同时引入了"队长battle"环节，让比赛更加激烈。舞台设计也全面升级，每一场公演都堪比专业演唱会水准。</p>

<h3>社会意义</h3>
<p>《乘风破浪的姐姐》不仅仅是一档综艺节目，它传递了一种"年龄不是限制，梦想永远年轻"的价值观。节目激励了无数观众勇敢追求自己的梦想，无论处于人生的哪个阶段。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20stage%20performance%20with%20female%20performers%20in%20flowing%20dresses%2C%20dramatic%20spotlight%2C%20warm%20golden%20and%20rose%20lighting%2C%20artistic%20style%2C%20glamorous%20theatrical%20atmosphere&width=800&height=450&seq=article-cl-01&orientation=landscape',
  },
  'douluo-2': {
    title: '斗罗大陆2：绝世唐门',
    category: '动漫',
    rating: 9.4,
    updateTo: '更新至52集',
    year: 2024,
    region: '中国大陆',
    director: '玄机科技',
    cast: '配音：赵乾景、陶典、杨梦露等',
    description: '《斗罗大陆2：绝世唐门》是斗罗系列的续作，故事发生在第一部的万年之后。霍雨浩，一个拥有灵眸武魂的少年，在史莱克学院开启了他的传奇之旅。',
    content: `<p>《斗罗大陆2：绝世唐门》——国产动漫的新标杆！玄机科技用顶级的制作水准，为观众呈现了一个更加宏大的斗罗世界。</p>

<h3>故事背景</h3>
<p>故事发生在唐三飞升神界万年之后，斗罗大陆已经进入了新的时代。魂导器的兴起改变了整个大陆的格局，日月帝国的崛起对史莱克学院构成了前所未有的威胁。少年霍雨浩在命运的安排下来到史莱克学院，开始了一段传奇的成长之旅。</p>

<h3>制作水准</h3>
<p>《绝世唐门》在画面质量上达到了国产动漫的新高度。角色建模精细到毛孔级别，场景渲染具有电影级质感。战斗场面的特效更是令人眼花缭乱，每一场魂技对决都是一场视觉盛宴。</p>

<h3>配音阵容</h3>
<p>本作采用了国内顶级配音团队，每一位角色的声音都与其性格完美契合。霍雨浩的少年感、王冬的傲娇、贝贝的温柔，都通过声音得到了精准的传达。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20fantasy%20scene%20with%20young%20warrior%20and%20glowing%20spirit%20animals%2C%20warm%20amber%20and%20golden%20lighting%2C%20epic%20atmosphere%2C%20artistic%20illustration%20style&width=800&height=450&seq=article-dl-01&orientation=landscape',
  },
  'fanhua': {
    title: '繁花',
    category: '电视剧',
    rating: 9.6,
    updateTo: '全30集',
    year: 2024,
    region: '中国大陆',
    director: '王家卫',
    cast: '胡歌、马伊琍、唐嫣、辛芷蕾',
    description: '王家卫首部电视剧作品《繁花》，改编自金宇澄同名小说。以上世纪90年代的上海为背景，讲述了一群年轻人在时代浪潮中的奋斗与爱情。',
    content: `<p>《繁花》——王家卫的电视剧首秀，一部关于上海的视觉诗篇。这位世界级导演用电影级的制作标准，为观众呈现了一幅90年代上海的浮世绘。</p>

<h3>导演风格</h3>
<p>王家卫标志性的视觉美学在《繁花》中得到了充分展现。每一帧画面都经过精心构图和调色，复古的色调、精致的道具、考究的服装，将观众瞬间带回那个充满机遇与梦想的年代。慢镜头、爵士乐、独白式的叙事，都是王家卫的经典元素。</p>

<h3>演员表现</h3>
<p>胡歌饰演的阿宝是整部剧的灵魂人物，他将一个上海"老克勒"的精明、义气与柔情演绎得淋漓尽致。马伊琍、唐嫣、辛芷蕾三位女演员各自塑造了性格迥异的女性形象，她们与阿宝之间的情感纠葛构成了剧集的核心线索。</p>

<h3>时代意义</h3>
<p>《繁花》不仅仅是一部电视剧，它是对一个时代的致敬。90年代的上海，是中国改革开放的前沿阵地，无数人在这里追寻梦想、创造奇迹。《繁花》用细腻的笔触描绘了那个充满活力与希望的时代。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Nostalgic%20Shanghai%20street%20scene%20in%201990s%20with%20neon%20lights%20and%20vintage%20cars%2C%20warm%20golden%20and%20amber%20tones%2C%20cinematic%20Wong%20Kar-wai%20style%2C%20artistic%20atmosphere&width=800&height=450&seq=article-fh-01&orientation=landscape',
  },
  'feichi-2': {
    title: '飞驰人生2',
    category: '电影',
    rating: 8.9,
    updateTo: 'HD高清',
    year: 2024,
    region: '中国大陆',
    director: '韩寒',
    cast: '沈腾、范丞丞、尹正、张本煜',
    description: '韩寒导演携《飞驰人生2》回归！曾经的赛车冠军张驰再次踏上赛道，这一次他要面对的不仅是速度的挑战，更是人生的重新起航。',
    content: `<p>《飞驰人生2》——速度与笑料的完美结合！韩寒导演再次用他独特的幽默感和对赛车的热爱，为观众带来了一场酣畅淋漓的观影体验。</p>

<h3>剧情升级</h3>
<p>第二部的故事发生在第一部几年之后，张驰已经从一名落魄的赛车手成长为驾校教练。然而，当命运再次给他一个重返赛场的机会时，他毫不犹豫地选择了接受挑战。这一次，他不仅要面对更加强大的对手，还要带领一支全新的团队。</p>

<h3>喜剧元素</h3>
<p>沈腾的喜剧天赋在第二部中得到了更加充分的发挥。他与范丞丞组成的"师徒档"产生了奇妙的化学反应，两人之间的互动笑料不断。尹正和张本煜的配角表现也十分出彩，为影片增添了更多欢乐。</p>

<h3>赛车场面</h3>
<p>第二部的赛车场面相比第一部有了质的飞跃。实景拍摄比例大幅增加，巴音布鲁克拉力赛的壮美风光和惊险赛道被完美呈现在大银幕上。每一个弯道超车、每一次极限漂移都让人肾上腺素飙升。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20racing%20movie%20scene%20with%20race%20cars%20on%20desert%20track%2C%20warm%20golden%20sunset%20lighting%2C%20dynamic%20motion%2C%20cinematic%20style%2C%20epic%20atmosphere&width=800&height=450&seq=article-fc-01&orientation=landscape',
  },
};

export const defaultArticles = [
  { id: 'qingyunian-2', title: '庆余年 第二季' },
  { id: 'liulangdiqiu-3', title: '流浪地球3' },
  { id: 'chenglang-5', title: '乘风破浪的姐姐 第五季' },
  { id: 'douluo-2', title: '斗罗大陆2：绝世唐门' },
  { id: 'fanhua', title: '繁花' },
  { id: 'feichi-2', title: '飞驰人生2' },
];